const AULA_AUTH_TOKEN_COOKIE = 'aula_auth_token';
const AULA_USER_DATA_COOKIE = 'aula_user_data';

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : null;
};

const setCookie = (name, value, days = 1) => {
  if (typeof document === 'undefined') return;
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

const deleteCookie = (name) => {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

class AulaSessionService {
  getToken() {
    const token = getCookie(AULA_AUTH_TOKEN_COOKIE);
    if (!token) return null;
    try {
      return decodeURIComponent(token);
    } catch (_) {
      return token;
    }
  }

  getUser() {
    const raw = getCookie(AULA_USER_DATA_COOKIE);
    if (!raw) return null;
    try {
      return JSON.parse(decodeURIComponent(raw));
    } catch (_) {
      return null;
    }
  }

  setSession(session = {}) {
    if (!session?.token) return;
    const userData = {
      token: session.token,
      aulaId: session.aulaId,
      idColegio: session.idColegio,
      idCurso: session.idCurso || null,
      idUsuario: session.idUsuario,
      idRol: session.idRol,
      nombreRol: session.nombreRol,
      displayName: session.displayName,
      nombre: session.nombre || '',
      apellido: session.apellido || '',
      email: session.email
    };

    setCookie(AULA_AUTH_TOKEN_COOKIE, encodeURIComponent(session.token), 1);
    setCookie(AULA_USER_DATA_COOKIE, encodeURIComponent(JSON.stringify(userData)), 1);
  }

  clearSession() {
    deleteCookie(AULA_AUTH_TOKEN_COOKIE);
    deleteCookie(AULA_USER_DATA_COOKIE);
  }

  isAuthenticated() {
    return Boolean(this.getToken() && this.getUser());
  }

  getFullName() {
    const user = this.getUser();
    if (!user) return '';
    const fullName = `${user.nombre || ''} ${user.apellido || ''}`.trim();
    return fullName || user.displayName || user.email || '';
  }
}

const aulaSessionService = new AulaSessionService();
export default aulaSessionService;
